<template>
  <div class="brand_rank">
    <!-- 8. 品牌排名 -->
    <titleTem :passTitleData="passTitleData"></titleTem>
    <!-- 搜索条件 -->
    <div class="condition_search">
      <el-row>
        <!-- 选择地区 -->
        <el-col :md="24" :lg="10">
          <div class="option region">
            <div class="item_title">Select Region:</div>
            <el-select
              v-model="regionVal"
              clearable
              placeholder="Please choose"
              :popper-append-to-body="false"    
              @change="changeArea"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </div>
        </el-col>
        <!-- 选择时间 -->
        <el-col :md="24" :lg="14">
          <div class="option time">
            <div class="time">
              <el-row>
                <el-col :md="24" :lg="5">
                  <div class="item_title date_item">Select Time:</div>
                </el-col>
                <el-col :md="24" :lg="19" v-if="!isMyDate">
                  <el-date-picker
                    @blur="getStartDate"
                    type="date"
                    placeholder="Start date"
                    v-model="startDate"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptionsStart"
                    size="large"
                  ></el-date-picker>
                  <span class="to_txt">&nbsp;&nbsp;to&nbsp;&nbsp;</span>
                  <el-date-picker
                    @blur="getEndDate"
                    type="date"
                    placeholder="End date"
                    v-model="endDate"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptionsEnd"
                    size="large"
                  ></el-date-picker>
                </el-col>
                <el-col :md="24" :lg="19" v-else>
                  <DatePicker
                    :startTime="startDate"
                    :endTime="endDate"
                    @startConfirm="startConfirm"
                    @endConfirm="endConfirm"
                    @startCancel="startCancel"
                    @endCancel="endCancel"
                    @startClear="startClear"
                    @endClear="endClear"
                  ></DatePicker>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>

        <el-col :md="24">
          <div class="option region_det">
            <div class="item_title">Select Region:</div>
            <el-tag
              :key="tag.value"
              v-for="tag in dynamicTags"
              closable
              type="info"
              :disable-transitions="false"
              @click="getContent(tag)"
              @close="handleClose(tag)"
            >{{tag.value}}</el-tag>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="echarts_container home_echarts bar_style">
      <EBar :echartsData="echartsData" :numShow="true" :isNodata="isNodata"></EBar>
    </div>
  </div>
</template>

<script>
import titleTem from "../overseas_components/Title";
import EBar from "./components/ActivityEbar";
import {
  listofCountries,
  industryActivity
} from "@/common/js/http/version3Api.js";
import DatePicker from "../mobile/DatePickerLocal";
export default {
  name: "BrandRank",
  props: {
    country: {
      type: Array,
      default: () => []
    }
  },
  components: {
    titleTem,
    EBar,
    DatePicker
  },
  data() {
    return {
      isMyDate: false,
      isNodata: false,
      pickerOptionsStart: {
        disabledDate: time => {
          // let endDateVal = this.endDate;
          // if (endDateVal) {
          //   return time.getTime() > new Date(endDateVal).getTime();
          // }
          if(this.endDate === '' || this.endDate !== '') {
            let endDateVal = 1561910461 * 1000;
            if (endDateVal) {
              return time.getTime() < 1561910461 * 1000 || time.getTime() > new Date(this.endDate).getTime();
            }
          }else {
            let endDateVal = this.endDate;
            if(endDateVal) {
              return time.getTime() > new Date(endDateVal).getTime();
            }
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          // let beginDateVal = this.startDate;
          // if (beginDateVal) {
          //   return time.getTime() < new Date(beginDateVal).getTime();
          // }
          if(this.startDate === '') {
            let beginDateVal = 1561910461 * 1000;
            if (beginDateVal) {
              return time.getTime() < 1561910461 * 1000
            }
          }else {
            let beginDateVal = this.startDate;
            if(beginDateVal) {
              return time.getTime() < new Date(beginDateVal).getTime();
            }
          }
        }
      },
      passTitleData: {
        titleName: "Industry Vitality",
        commentTxt: "It shows statistics of the news postings in top 15 industries in some regions (top5 by the number of postings) within a certain time range (in past 30 days by default)."
      },

      //柱状图数据
      echartsData: [],

      // 搜索条件
      clickState: false,
      regionVal: "",
      brandVal: "",
      startDate: "",
      endDate: "",
      dynamicTags: [],
      options: [],
      dynamicTags1: [],
      options1: [],
      brandArray: [],
      countryArray: [],
      makeArray: [],
      regionalArray: [],
      timer: null
    };
  },
   created() {
    this.setDate();
    //屏幕宽度
    if(document.documentElement.clientWidth < 768) {
      this.isMyDate = true
    }else {
      this.isMyDate = false
    }
  },
  mounted() {
    this.timer = setTimeout(() => {
      this.getIndustryActivity();
    }, 500)
    
  },
  methods: {
    setDate() {
      this.startDate = this.$moment(new Date())
        .subtract(30, "days")
        .format("YYYY-MM-DD");
      this.endDate = this.$moment(new Date()).format("YYYY-MM-DD");
    },
    getStartDate() {
      this.getIndustryActivity();
    },
    getEndDate() {
      this.getIndustryActivity();
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      this.regionalArray.filter(item => {
        if (item === tag.value) {
          this.regionalArray.splice(this.regionalArray.indexOf(tag.value), 1);
        }
      });
      this.options.filter(item => {
        if (item.value === tag.value) {
          item.disabled = false;
        }
      });
      this.regionVal = "";
      this.getIndustryActivity();
    },

    getIndustryActivity() {
      if (this.startDate == null || this.startDate == 'Invalid date') {
        this.startDate = "";
      }
      if (this.endDate == null || this.endDate == 'Invalid date') {
        this.endDate = "";
      }
      let data = {
        regionalNames: this.regionalArray,
        startTime: this.startDate,
        endTime: this.endDate
      };
      industryActivity(data).then(res => {
        let newsArray = [];
        let one = newsArray.push(res.result.yAxis.data, res.result.series);
        this.$set(this.echartsData, "lineData", newsArray);
        this.echartsData = this.echartsData.lineData;
        if (this.echartsData.length === 0) {
          this.isNodata = true;
        } else {
          this.isNodata = false;
        }
      });
    },
    //获取国家列表
    getlistofCountry() {
      this.options = this.country;
      this.options.map(item => {
        item.disabled = false;
        return item;
      });
    },
    //选择国家列表
    changeArea(val) {
      this.clickState = true;
      this.options.filter(item => {
        if (item.value === this.regionVal) {
          item.disabled = true;
        }
      });
      if (this.clickState === true && this.regionVal !== "") {
        this.countryArray.push({ value: this.regionVal });
        for (var i = 0; i < this.countryArray.length; i++) {
          for (var j = i + 1; j < this.countryArray.length; j++) {
            if (this.countryArray[i].value == this.countryArray[j].value) {
              this.countryArray.splice(j, 1);
              j--;
            }
          }
        }
        this.dynamicTags = this.countryArray;
        this.regionalArray.push(val);
        this.getIndustryActivity();
      }
    },
    //移动端日期
    startConfirm(startTime) {
      this.startDate = this.$moment(new Date(startTime)).format("YYYY-MM-DD");
      this.getIndustryActivity();
    },
    endConfirm(endTime) {
      this.endDate = this.$moment(new Date(endTime)).format("YYYY-MM-DD");
      this.getIndustryActivity();
    },
    startCancel() {
      this.startDate = "";
      this.getIndustryActivity();
    },
    endCancel() {
      this.endDate = "";
      this.getIndustryActivity();
    },
    startClear() {
      this.startDate = "";
      this.getIndustryActivity();
    },
    endClear() {
      this.endDate = "";
      this.getIndustryActivity();
    }
  },
  destroyed() {
    clearTimeout(this.timer)
  },
  watch: {
    startDate() {
      if (this.startDate == null) {
        this.getIndustryActivity();
      }
    },
    endDate() {
      if (this.endDate == null) {
        this.getIndustryActivity();
      }
    },
    changeArea() {
      this.getIndustryActivity();
    },
    country: {
      handler(newValue) {
        this.getlistofCountry()
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.echarts_container > div {
  height: auto !important;
}
.time >>> .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 125px !important;
}
.time >>> .el-input--suffix .el-input__inner {
  padding-right: 20px !important;
}
.time .date_item {
  margin-right: 0 !important;
  line-height: 32px !important;
  width: 90% !important;
  text-align: right !important;
  padding-right: 0;
}
.item_title {
  font-size: 14px;
  font-family: RCR;
  color: #4e5671;
  display: inline-block;
  padding-right: 10px;
}
@media screen and (max-width: 1206px) {
  .time .date_item {
    text-align: left !important;
  }
}
</style>